import { createFileRoute } from '@tanstack/react-router';
import { ConfigurationRiskMatrix } from './RiskMatrix';

export const Route = createFileRoute('/console/$orgId/configuration/risk/matrix')({
    staticData: { metadata: { title: 'Risk matrix' } },
    validateSearch({ newCategoryId }): Partial<{ newCategoryId: string }> {
        return {
            newCategoryId: newCategoryId ? String(newCategoryId) : undefined,
        };
    },
    component: () => <ConfigurationRiskMatrix />,
});
